import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SubscriptionEstimationFeatureApi, SubscriptionEstimationFeatureTranslation } from "../../../api/types";
import SubscriptionBasedRestrictionModalPlanFeature from "./SubscriptionBasedRestrictionModalPlanFeature";

interface Props {
	features: SubscriptionEstimationFeatureApi[];
	featureId: string;
	featureTranslations: SubscriptionEstimationFeatureTranslation[];
}

const SubscriptionBasedRestrictionModalPlanFeatures = ({ features, featureId, featureTranslations }: Props) => {
	const [showMore, setShowMore] = useState(false);
	const { t } = useTranslation();

	const getTranslationForFeature = (feature: SubscriptionEstimationFeatureApi) => {
		return featureTranslations.find(({ id }) => id === feature.id);
	};

	return (
		<div className="d-flex gap-2 flex-column">
			{(!showMore ? features.filter((_, index) => index < 5) : features).map((feature) => (
				<SubscriptionBasedRestrictionModalPlanFeature
					key={feature.id}
					bold={feature.id === featureId}
					translation={getTranslationForFeature(feature)}
					feature={feature}
				/>
			))}
			{features.length > 5 && (
				<small
					className="mb-0 text-primary show-more ms-4"
					onClick={() => setShowMore((prevState) => !prevState)}
				>
					{showMore
						? t("lib:common.action.show_less").toLowerCase()
						: t("lib:common.action.show_more").toLowerCase()}
				</small>
			)}
		</div>
	);
};

export default SubscriptionBasedRestrictionModalPlanFeatures;
